import { alpha } from '@mui/material/styles';
import Chip, { ChipProps } from '@mui/material/Chip';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import DoneIcon from '@mui/icons-material/Done';
import PendingActionsIcon from '@mui/icons-material/PendingActions';
import EventAvailableIcon from '@mui/icons-material/EventAvailable';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import ScheduleIcon from '@mui/icons-material/Schedule';
import ArchiveIcon from '@mui/icons-material/Archive';
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import RemoveCircleIcon from '@mui/icons-material/RemoveCircle';
import { InvoiceTableRowStatus, invoiceTableRowStatusToColor } from '@lendica/utils';

export const StatusChip = ({ status, ...props }: { status: InvoiceTableRowStatus } & ChipProps) => {
    const getStatus = (status: InvoiceTableRowStatus) => {
        switch (status) {
            case InvoiceTableRowStatus.Ready:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <DoneIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.UnderReview:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <PendingActionsIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.Active:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <EventAvailableIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.GracePeriod:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <ErrorOutlineIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.Late:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <ScheduleIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.PaidOff:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <DoneIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.Defaulted:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <NotInterestedIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.Archived:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <ArchiveIcon sx={{ cursor: 'auto !important' }} />,
                };
            case InvoiceTableRowStatus.Rejected:
                return {
                    color: invoiceTableRowStatusToColor[status],
                    icon: <RemoveCircleIcon sx={{ cursor: 'auto !important' }} />,
                };
            default:
                return {
                    color: 'gray',
                    icon: <DoneIcon sx={{ cursor: 'auto !important' }} />,
                };
        }
    };
    const { color, icon } = getStatus(status);

    return (
        <Chip
            label={status}
            size="small"
            sx={{
                backgroundColor: alpha('#202024', 0.04),
                border: '1px solid #ddd',
                ...(props?.sx || {}),
            }}
            icon={<FiberManualRecordIcon sx={{ color: `${color} !important` }} />}
            deleteIcon={icon}
            onDelete={e => {
                e.preventDefault();
                e.stopPropagation();
            }}
            {...props}
        />
    );
};
